import moment from 'moment'
import _ from 'lodash'
// import utilDate from '@/utils/date'

export default {

  updateGestationDate: function (data) {
    // console.debug('updateGestationDate: ')
    let forms = data.forms
    let formChanges = {}

    const kind = forms['gestationalAge.info.calculo']
    let gestationDate = null
    let ageInDays = null
    let weeks = null
    let days = null

    // if (kind === 'desconhecido') // Não faz nada
    if (kind === 'DUM') {
      gestationDate = forms['gestationalAge.info.dateTest']
      // gestationDate = utilDate.setZeroTime(gestationDate)
      ageInDays = moment(forms['gestationalAge.info.interationDate']).startOf('day').diff(moment(gestationDate).startOf('day'), 'days')
    } else if (kind === 'exame-anterior') {
      gestationDate = moment(forms['gestationalAge.info.dateTest'])
        .subtract(forms['gestationalAge.info.weeks'], 'weeks')
        .subtract(forms['gestationalAge.info.days'], 'days')
        .toDate()
      // gestationDate = utilDate.setZeroTime(gestationDate)
      ageInDays = moment(forms['gestationalAge.info.interationDate']).startOf('day').diff(moment(gestationDate).startOf('day'), 'days')
    } else if (kind === 'informada') {
      gestationDate = moment(forms['gestationalAge.info.interationDate'])
        .subtract(forms['gestationalAge.info.weeks'], 'weeks')
        .subtract(forms['gestationalAge.info.days'], 'days')
        .toDate()
      // gestationDate = utilDate.setZeroTime(gestationDate)
      ageInDays = moment(forms['gestationalAge.info.interationDate']).startOf('day').diff(moment(gestationDate).startOf('day'), 'days')
    } else if (kind === 'manual') {
      gestationDate = forms['gestationalAge.info.date']
      ageInDays = forms['gestationalAge.info.calculada']
      formChanges['gestationalAge.info.calculoRef'] = forms['gestationalAge.info.calculoRef']
    } else if (kind === 'data-parto') {
      if (forms['gestationalAge.info.dateTest']) {
        gestationDate = moment(forms['gestationalAge.info.dateTest']).startOf('day').subtract(280, 'days').toDate()
        // gestationDate = utilDate.setZeroTime(gestationDate)
        ageInDays = moment(forms['gestationalAge.info.interationDate']).startOf('day').diff(moment(gestationDate).startOf('day'), 'days')
      }
    }

    const base = {}
    if (kind === 'desconhecido') {
      base['gestationalAge.info.calculo'] = 'desconhecido'
      base['gestationalAge.info.date'] = null
      base['gestationalAge.info.dateTest'] = null
      base['gestationalAge.info.weeks'] = null
      base['gestationalAge.info.days'] = null
    } else {
      weeks = parseInt(ageInDays / 7)
      days = Math.round(ageInDays % 7)

      base['gestationalAge.info.calculo'] = 'exame-anterior'
      base['gestationalAge.info.date'] = _.clone(gestationDate)
      base['gestationalAge.info.dateTest'] = forms['gestationalAge.info.interationDate']
      base['gestationalAge.info.weeks'] = weeks
      base['gestationalAge.info.days'] = days
    }

    formChanges['gestationalAge.info.date'] = gestationDate || null
    formChanges['gestationalAge.info.calculada'] = ageInDays || null

    if (gestationDate) {
      formChanges['gestationalAge.info.dateParto'] = moment(gestationDate).add(280, 'days').toDate()
    } else {
      formChanges['gestationalAge.info.dateParto'] = null
    }

    if (['exame-anterior', 'informada'].includes(kind)) {
      formChanges['gestationalAge.info.weeks'] = forms['gestationalAge.info.weeks'] || null
      formChanges['gestationalAge.info.days'] = forms['gestationalAge.info.days'] || null
    } else {
      formChanges['gestationalAge.info.weeks'] = weeks
      formChanges['gestationalAge.info.days'] = days
    }

    return { forms: formChanges, gestation: { formsBase: base } }
  },

  updatePatientBirthdate: function (data, changes) {
    let resultChanges = {}
    const dateBirthMotherKey = 'gestationalAge.info.dateBirthMother'
    // Alteração via paciente
    if (changes.forms && changes.forms['patient.birthdate']) {
      if (!data || !data.forms || changes.forms['patient.birthdate'] !== data.forms[dateBirthMotherKey]) {
        resultChanges.forms = {}
        resultChanges.forms[dateBirthMotherKey] = changes.forms['patient.birthdate']
      }
    } else if (changes.forms && changes.forms[dateBirthMotherKey]) {
      // Via forms
      if (!data || !data.patient || data.patient.birthdate !== data.forms[dateBirthMotherKey]) {
        resultChanges.patient = { birthdate: changes.forms[dateBirthMotherKey] }
      }
    }
    return resultChanges
  },

  updateGestationInterationDate: function (val) {
    // this.gestationInteraction.date = moment(val).toDate()
    // db.doc('gestationInteraction/' + this.gestationInteraction.iuid).update({date: this.gestationInteraction.date})
    // this.updateGestationDate(this.gestationInteraction.date)
  },

  updateGestationFeto (data) {
    let forms = data.forms
    const base = {}
    base['gestationalAge.info.fetos'] = forms['gestationalAge.info.fetos']
    return { gestation: { formsBase: base } }
  },

  updateGestationSaco (data) {
    let forms = data.forms
    const base = {}
    base['gestationalAge.info.qtdSacoGestacional'] = forms['gestationalAge.info.qtdSacoGestacional']
    return { gestation: { formsBase: base } }
  },
  updateNumeroNodulo (data) {
    let forms = data.forms
    const base = {}
    base['examemama.mamaDireita.miomas'] = forms['examemama.mamaDireita.miomas']
    return { gestation: { formsBase: base } }
  },
  updateNumeroLinfonodo (data) {
    let forms = data.forms
    const base = {}
    base['examemama.mamaEsquerda.miomas'] = forms['examemama.mamaDireita.miomas']
    return { gestation: { formsBase: base } }
  },
  updateCycleDay (data) {
    let forms = data.forms
    const formChanges = {}
    let date = moment().startOf('day').diff(moment(forms['gynecologic.biometria.lastPeriod']).startOf('day'), 'days')
    formChanges['gynecologic.biometria.cycleDay'] = date
    return { forms: formChanges }
  },

  updateGestation (field, val) {
    // if (!this.gestation.iuid || this.gestation[field] === val) return
    //
    // this.gestationTemp[field] = val
    // this.saveGestation()
  }

}



// WEBPACK FOOTER //
// ./src/api/formEvents.js